<div class="quick-action-button-wrapper">
  <ng-container *ngFor="let btn of quickActionsButtons">
    <app-quick-action-button [userQuickActionButton]="btn"
                             [isLoading]="isLoading"
                             [buttonDisabled]="isButtonDisabled(btn.id)"
    (buttonClick)="onButtonClicked($event)"  ></app-quick-action-button>
  </ng-container>
</div>
